import { Bullseye, Page } from '@patternfly/react-core';
import * as React from 'react';

interface IMinimalLayout {
  children: React.ReactNode;
}

export const MinimalLayout: React.FunctionComponent<IMinimalLayout> = ({ children }) => {
  return (
    <Page
      style={{
        height: '100vh',
        margin: 0,
        padding: 0,
        ['--pf-v6-c-page__main-container--MaxHeight' as any]: '100%',
        ['--pf-v6-c-page--inset' as any]: '0',
        ['--pf-t--global--spacer--inset--page-chrome' as any]: '0',
        ['--pf-v6-c-page__main-container--BorderRadius' as any]: '0'
      }}
      sidebar={null}
    >
      <Bullseye style={{ height: '100%', margin: 0, padding: 0 }}>
        {children}
      </Bullseye>
    </Page>
  );
};